import type { Session } from './types.js';

export async function api<T>(path: string, init: RequestInit = {}, csrfToken?: string | null): Promise<T> {
  const headers = new Headers(init.headers);
  if (init.body) headers.set('content-type', 'application/json');
  if (csrfToken) headers.set('x-csrf-token', csrfToken);
  const response = await fetch(path, { ...init, headers, credentials: 'same-origin' });
  if (!response.ok) {
    const payload = (await response.json().catch(() => null)) as { error?: { message?: string } } | null;
    throw new Error(payload?.error?.message ?? 'Не удалось выполнить запрос');
  }
  if (response.status === 204) return undefined as T;
  return response.json() as Promise<T>;
}

export const loadSession = () => api<Session>('/api/session');
